import * as JSURL from '@yaska-eu/jsurl2';

export enum DevFlags {
    EnableApolloPersistCache = 'apd_use_apollo_persist_cache',
    LogGraphQLRequest = 'apd_log_graphql_request_details',
    EnableDebugLog = 'apd_enable_debug_log',
    DisableTraceId = 'apd_disable_trace_id',
}

export function boolDevFlag(key: string, defaultValue: boolean, localStorage: Storage = window.localStorage): boolean {
    try {
        const result = localStorage.getItem(key);
        return result === null ? defaultValue : Boolean(JSURL.parse(result));
    } catch {
        return defaultValue;
    }
}

export function devFlagHelp() {
    console.debug(`

    // By default debug log is disabled in Production environment; you can enable them using this flag
    localStorage.${DevFlags.EnableDebugLog} = 1;
    localStorage.${DevFlags.EnableDebugLog} = 0; // disable

    // If you want to cache GraphQL requests which takes long
    localStorage.${DevFlags.EnableApolloPersistCache} = 1;
    localStorage.${DevFlags.EnableApolloPersistCache} = 0; // disable

    // If you want see params for each  GraphQL request to easy reproduce them with /graphiql
    // in Production environment should be used alongside with localStorage.${DevFlags.EnableDebugLog} = 1;
    localStorage.${DevFlags.LogGraphQLRequest} = 1;
    localStorage.${DevFlags.LogGraphQLRequest} = 0; // disable

`);
}
